module.exports = __webpack_public_path__ + "img/symbol_9.97c513d2.png";